import { useQuery } from '@apollo/client/react';
import { BookingDetails } from '@drycut/booking-components';
import { GetBookingDocument } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

import BookingPubSubWrapper from '../BookingPubSubWrapper';
import { useGtagEvent } from '../hooks';

export function BookingDetailsByUid(): React.ReactElement {
  useDocumentTitle('DRYCUT - Booking details');

  const { uid } = useParams() as { uid: string };
  const { data, loading } = useQuery(GetBookingDocument, { variables: { uid } });
  const { sendEvent } = useGtagEvent();

  // Send conversion event to Google
  useEffect(() => {
    sendEvent('conversion', {
      send_to: 'AW-866373683/nrFyCJqU6cQaELOgj50D',
    });
  }, [sendEvent]);

  const booking = data?.booking;

  if (loading || !booking) {
    return <Loader />;
  }

  return (
    <BookingPubSubWrapper uid={uid}>
      <BookingDetails booking={booking} />
    </BookingPubSubWrapper>
  );
}
